import {
  Accordion as UIAccordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from "@emisgroup/ui-accordion";
import React from "react";
import { AccordionType } from "./Types";

export interface AccordionProps {
  /**
   * Data source for this component
   */
  data: AccordionType[];
  /**
   * AccordionId
   */
  accordionId: string;
  /**
   * Default value to open the sections
   */
  defaultOpenSection: number;
}

/**
 * To render the accordion component
 * @param props accordion props
 * @returns the accordion element
 */
export const Accordion = (props: AccordionProps): JSX.Element => {
  const { accordionId, defaultOpenSection } = props;

  return (
    <UIAccordion
      type="multiple"
      id={`ebt-${accordionId}-accordion`}
      defaultValue={[props.data[defaultOpenSection]?.name]}
    >
      {props?.data?.map((header: AccordionType, index: number) => {
        const { name, content, className, onAccordionClick } = header;
        return (
          <AccordionItem
            key={`${name}${index}`}
            borderless={true}
            value={name}
            id={`ebt-${accordionId}-accordion-item`}
          >
            <div className={className} onClick={onAccordionClick}>
              <AccordionHeader id={`ebt-accordion-header-${name}-${accordionId}`}>
                <AccordionTrigger id={`ebt-accordion-trigger-${name}-${accordionId}`}>
                  {name}
                </AccordionTrigger>
              </AccordionHeader>
            </div>
            <AccordionContent
              id={`ebt-accordion-content-${name.split(" ")[0]}`}
              className={`ebt-accordion-content-${name.split(" ")[0]}`}
            >
              {content}
            </AccordionContent>
          </AccordionItem>
        );
      }
      )}
    </UIAccordion>
  );
};
